<template>
  <div>
    <div v-if="variant === 'multi'">
      <el-form
        :model="auth"
        ref="form"
        label-width="0px"
        class="authorize-form"
      >
        <div
          v-if="auth && auth.work_site"
          class="authorize-form__row authorize-form__row_full"
        >
          <div class="authorize-form__field">
            <span class="el-form-item__label">Площадка</span>
            <Dropdown
              hasLeftIcon
              size="big"
              :options="workSiteOptions"
              :field="{
                type: 'enum',
                placeholder: 'Выберите',
                disabled: auth.work_site !== 'career_page'
              }"
              :clearable="false"
              :model="platformName"
              placeholder="Выберите"
              class="authorize-form__input authorize-form__input_sm"
              @set-value="(name, value) => changePlatformName(value)"
            />
          </div>
          <div
            v-if="auth.work_site !== 'career_page'"
            class="authorize-form__field"
          >
            <span class="el-form-item__label">Учетная запись</span>
            <el-input
              :field="field"
              :value="`${auth.first_name} ${auth.last_name}`"
              :disabled="true"
              size="big"
              class="authorize-form__input authorize-form__input_lg big"
            />
          </div>
          <div
            v-if="
              auth.work_site !== 'career_page' && auth.work_site !== 'trudvsem'
            "
            class="authorize-form__field"
          >
            <span
              class="el-form-item__label"
              :style="platformName ? 'display:inline' : ''"
            >
              Тарифный план
              <span v-if="platformName" class="required-star">*</span></span
            >
            <el-input
              v-if="
                selectedVacancy &&
                field.billingTypes &&
                (auth.work_site == 'rabotaru'
                  ? selectedVacancy.status.value !== 'draft' &&
                    selectedVacancy.status.value !== 'unpublished'
                  : selectedVacancy.status.value !== 'draft')
              "
              :field="field"
              :value="field.billingTypes[selectedVacancy.billing_type_id.value]"
              :disabled="true"
              size="big"
              class="authorize-form__input authorize-form__input_sm big"
            />
            <Dropdown
              v-else
              size="big"
              :options="field.billingTypes"
              :model="billingType"
              :field="{
                type: 'enum',
                placeholder: 'Выберите',
                required: auth.work_site == 'rabotaru'
              }"
              disabled
              :clearable="false"
              placeholder="Выберите"
              class="authorize-form__input authorize-form__input_mid"
              @set-value="(name, value) => (billingType = value)"
            />
          </div>
          <div
            v-else-if="auth.work_site == 'trudvsem'"
            :class="
              ('authorize-form__field',
              selectedVacancy && field.billingTypes
                ? 'authorize-form__input_sm'
                : 'authorize-form__input_mid')
            "
          ></div>
          <ActionsMenu
            v-if="auth.work_site !== 'career_page'"
            :actions="
              deleteField
                ? [
                    { id: 'delete', name: 'Удалить из списка' },
                    { id: 'exit', name: 'Выйти' }
                  ]
                : [{ id: 'exit', name: 'Выйти' }]
            "
            class="actions_menu"
            type="pointsMenu"
            @handleCommand="p => handleCommand(p.id)"
            color="#21272C"
          />
          <div
            v-if="deleteField && auth.work_site == 'career_page'"
            class="authorize-form__delete"
          >
            <div @click="handleCommand('delete')">
              <Icon iconName="delete" iconColor="#C0C8D0" />
            </div>
          </div>
        </div>

        <div v-else class="authorize-form__row">
          <div class="authorize-form__field">
            <span class="el-form-item__label">Площадка</span>
            <Dropdown
              hasLeftIcon
              size="big"
              :options="workSiteOptions"
              :field="{ type: 'enum', placeholder: 'Выберите' }"
              :model="platformName"
              :clearable="false"
              placeholder="Выберите"
              class="authorize-form__input authorize-form__input_sm"
              @set-value="(name, value) => changePlatformName(value)"
            />
          </div>
          <div
            v-if="auth.work_site == 'trudvsem' || platformName == 'trudvsem'"
            class="authorize-form__field login-record"
          >
            <span class="el-form-item__label">Логин</span>
            <CustInput
              :field="{
                name: 'login',
                type: 'text',
                placeholder: 'Введите'
              }"
              :model="authForm['login'] || ''"
              size="big"
              @set-value="setAuthValue"
              class="authorize-form__input authorize-form__input_lg big"
            />
          </div>
          <div
            v-if="auth.work_site == 'trudvsem' || platformName == 'trudvsem'"
            class="authorize-form__field login-record"
          >
            <span class="el-form-item__label">Пароль</span>
            <CustInput
              :field="{
                name: 'password',
                type: 'text',
                placeholder: 'Введите'
              }"
              :model="authForm['password'] || ''"
              size="big"
              @set-value="setAuthValue"
              class="authorize-form__input authorize-form__input_lg big"
            />
          </div>
          <Button
            v-if="
              auth.work_site !== 'career_page' || platformName !== 'career_page'
            "
            buttonSize="big"
            :buttonColor="
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? 'blue'
                : 'darkBlue'
            "
            :buttonText="
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? ''
                : 'Авторизация'
            "
            hasRightIcon
            :iconName="
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? 'Enter'
                : 'LinkBold'
            "
            :class="`authorize-form__button
            ${
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? 'authorize-form__button_log'
                : 'authorize-form__button_auth'
            }`"
            @click="authenticate"
          />
          <div v-if="deleteField" class="authorize-form__delete">
            <div @click="handleCommand('delete')">
              <Icon iconName="delete" iconColor="#C0C8D0" />
            </div>
          </div>
        </div>
      </el-form>
    </div>

    <div v-if="variant === 'single'">
      <el-form
        :model="auth"
        ref="form"
        label-width="0px"
        class="authorize-form"
      >
        <div
          v-if="auth && auth.work_site"
          class="authorize-form__row authorize-form__row_full"
        >
          <div class="authorize-form__field">
            <span class="el-form-item__label">Площадка</span>
            <Dropdown
              hasLeftIcon
              size="big"
              :options="workSiteOptions"
              :clearable="false"
              :field="{ type: 'enum', placeholder: 'Выберите', disabled: true }"
              :model="platformName"
              class="authorize-form__input authorize-form__input_sm"
            />
          </div>
          <div
            v-if="auth.work_site !== 'career_page'"
            class="authorize-form__field login-record"
          >
            <span class="el-form-item__label">Учетная запись</span>
            <el-input
              :field="field"
              :value="`${auth.first_name} ${auth.last_name}`"
              :disabled="true"
              size="big"
              class="authorize-form__input authorize-form__input_lg big"
            />
          </div>
          <Button
            v-if="auth.work_site !== 'career_page'"
            buttonSize="big"
            buttonColor="darkBlue"
            buttonText="Выйти"
            hasRightIcon
            iconName="LinkBold"
            class="authorize-form__button authorize-form__button_auth"
            @click="handleCommand('exit')"
          />
        </div>

        <div v-else class="authorize-form__row">
          <div class="authorize-form__field">
            <span class="el-form-item__label">Площадка</span>
            <Dropdown
              hasLeftIcon
              size="big"
              :options="workSiteOptions"
              :field="{ type: 'enum', placeholder: 'Выберите' }"
              :model="platformName"
              :clearable="false"
              class="authorize-form__input authorize-form__input_sm"
              @set-value="(name, value) => changePlatformName(value)"
            />
          </div>
          <div
            v-if="auth.work_site == 'trudvsem' || platformName == 'trudvsem'"
            class="authorize-form__field login-record"
          >
            <span class="el-form-item__label">Логин</span>
            <CustInput
              :field="{
                name: 'login',
                type: 'text',
                placeholder: 'Введите'
              }"
              :model="authForm['login'] || ''"
              size="big"
              @set-value="setAuthValue"
              class="authorize-form__input authorize-form__input_lg big"
            />
          </div>
          <div
            v-if="auth.work_site == 'trudvsem' || platformName == 'trudvsem'"
            class="authorize-form__field login-record"
          >
            <span class="el-form-item__label">Пароль</span>
            <CustInput
              :field="{
                name: 'password',
                type: 'text',
                placeholder: 'Введите'
              }"
              :model="authForm['password'] || ''"
              size="big"
              @set-value="setAuthValue"
              class="authorize-form__input authorize-form__input_lg big"
            />
          </div>
          <Button
            v-if="
              auth.work_site !== 'career_page' || platformName !== 'career_page'
            "
            buttonSize="big"
            :buttonColor="
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? 'blue'
                : 'darkBlue'
            "
            :buttonText="
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? ''
                : 'Авторизация'
            "
            hasRightIcon
            :iconName="
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? 'Enter'
                : 'LinkBold'
            "
            :class="`authorize-form__button
            ${
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? 'authorize-form__button_log'
                : 'authorize-form__button_auth'
            }`"
            @click="authenticate"
          />
        </div>
      </el-form>
    </div>

    <div v-if="variant === 'edit'">
      <el-form
        :model="auth"
        ref="form"
        label-width="0px"
        class="authorize-form"
      >
        <div
          v-if="auth && auth.work_site"
          class="authorize-form__row authorize-form__row_full"
        >
          <div class="authorize-form__field">
            <span class="el-form-item__label">Площадка</span>
            <Dropdown
              hasLeftIcon
              size="big"
              disabled
              :options="{ [platformName]: platformLabel(platformName) }"
              :field="{ type: 'enum', placeholder: 'Выберите', disabled: true }"
              :model="platformName"
              :clearable="false"
              class="authorize-form__input authorize-form__input_sm"
              @set-value="(name, value) => changePlatformName(value)"
            />
          </div>
          <div
            v-if="
              auth.work_site !== 'career_page' && auth.work_site !== 'trudvsem'
            "
            class="authorize-form__field"
          >
            <span class="el-form-item__label">Учетная запись</span>
            <el-input
              :field="field"
              :value="`${auth.first_name} ${auth.last_name}`"
              :disabled="true"
              size="big"
              class="authorize-form__input authorize-form__input_lg big"
            />
          </div>
          <div
            v-if="
              auth.work_site !== 'career_page' && auth.work_site !== 'trudvsem'
            "
            class="authorize-form__field"
          >
            <span
              class="el-form-item__label"
              :style="platformName ? 'display:inline' : ''"
              >Тарифный план
              <span v-if="platformName" class="required-star">*</span>
            </span>
            <el-input
              v-if="
                selectedVacancy &&
                field.billingTypes &&
                (auth.work_site == 'rabotaru'
                  ? selectedVacancy.status.value !== 'draft' &&
                    selectedVacancy.status.value !== 'unpublished'
                  : selectedVacancy.status.value !== 'draft')
              "
              :field="field"
              :value="field.billingTypes[selectedVacancy.billing_type_id.value]"
              :disabled="true"
              size="big"
              class="authorize-form__input authorize-form__input_sm big"
            />
            <Dropdown
              v-else
              size="big"
              :options="field.billingTypes"
              :model="billingType"
              :field="{
                type: 'enum',
                placeholder: 'Выберите',
                required: auth.work_site == 'rabotaru'
              }"
              disabled
              :clearable="false"
              class="authorize-form__input authorize-form__input_mid"
              @set-value="(name, value) => (billingType = value)"
            />
          </div>
          <div
            v-else-if="auth.work_site == 'trudvsem'"
            :class="
              ('authorize-form__field',
              selectedVacancy && field.billingTypes
                ? 'authorize-form__input_sm'
                : 'authorize-form__input_mid')
            "
          ></div>
          <ActionsMenu
            v-if="auth.work_site !== 'career_page'"
            :actions="
              deleteField
                ? [
                    { id: 'delete', name: 'Удалить из списка' },
                    { id: 'exit', name: 'Выйти' }
                  ]
                : [{ id: 'exit', name: 'Выйти' }]
            "
            class="actions_menu"
            @handleCommand="p => handleCommand(p.id)"
            :type="
              auth.work_site == 'trudvsem' && selectedVacancy?.duplicate
                ? 'pointsMenu'
                : ''
            "
            color="#21272C"
          />
          <div
            v-if="deleteField && auth.work_site == 'career_page'"
            class="authorize-form__delete"
          >
            <div @click="handleCommand('delete')">
              <Icon iconName="delete" iconColor="#C0C8D0" />
            </div>
          </div>
        </div>

        <div v-else class="authorize-form__row">
          <div class="authorize-form__field">
            <span class="el-form-item__label">Площадка</span>
            <Dropdown
              hasLeftIcon
              size="big"
              disabled
              :options="{ [platformName]: platformLabel(platformName) }"
              :field="{ type: 'enum', placeholder: 'Выберите' }"
              :model="platformName"
              :clearable="false"
              class="authorize-form__input authorize-form__input_sm"
              @set-value="(name, value) => changePlatformName(value)"
            />
          </div>
          <div
            v-if="auth.work_site == 'trudvsem' || platformName == 'trudvsem'"
            class="authorize-form__field login-record"
          >
            <span class="el-form-item__label">Логин</span>
            <CustInput
              :field="{
                name: 'login',
                type: 'text',
                placeholder: 'Введите'
              }"
              :model="authForm['login'] || ''"
              size="big"
              @set-value="setAuthValue"
              class="authorize-form__input authorize-form__input_lg big"
            />
          </div>
          <div
            v-if="auth.work_site == 'trudvsem' || platformName == 'trudvsem'"
            class="authorize-form__field login-record"
          >
            <span class="el-form-item__label">Пароль</span>
            <CustInput
              :field="{
                name: 'password',
                type: 'text',
                placeholder: 'Введите'
              }"
              :model="authForm['password'] || ''"
              size="big"
              @set-value="setAuthValue"
              class="authorize-form__input authorize-form__input_lg big"
            />
          </div>

          <Button
            v-if="
              auth.work_site !== 'career_page' || platformName !== 'career_page'
            "
            :buttonColor="
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? 'blue'
                : 'darkBlue'
            "
            :buttonText="
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? ''
                : 'Авторизация'
            "
            hasRightIcon
            :iconName="
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? 'Enter'
                : 'LinkBold'
            "
            :class="`authorize-form__button
            ${
              auth.work_site == 'trudvsem' || platformName == 'trudvsem'
                ? 'authorize-form__button_log'
                : 'authorize-form__button_auth'
            }`"
            @click="authenticate"
          />
          <div v-if="deleteField" class="authorize-form__delete">
            <div @click="handleCommand('delete')">
              <Icon iconName="delete" iconColor="#C0C8D0" />
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { store } from '@/store';
import { Form, Input } from 'element-ui';
import { form, mixin } from '@/utils/mixins';
import { scrollToError } from '@/utils/helpers';
import ActionsMenu from 'Elements/Menu/ActionsMenu';
import Dropdown from 'Elements/Select/Dropdown';
import Button from 'Elements/Button/Button';
import Icon from 'Elements/Icon/Icon';
import CustInput from 'Elements/Input/Input';

export default {
  mixins: [form, mixin],
  components: {
    'el-form': Form,
    'el-input': Input,
    Dropdown,
    Button,
    ActionsMenu,
    Icon,
    CustInput
  },
  props: {
    field: {
      type: Object,
      default: () => ({})
    },
    tabs: {
      type: Function
    },
    options: {
      type: [Object, Array]
    },
    variant: {
      type: String,
      default: 'multi'
    },
    isPopup: {
      type: Boolean,
      default: false
    },
    platformName: {
      type: String,
      default: 'career_page' /* 'hh' */
    },
    delete: {
      type: Function
    },
    deleteField: {
      type: Boolean,
      default: false
    },
    disabledField: { type: Boolean, default: false },
    selectedVacancy: Object
  },
  data() {
    return {
      work_site: 'career_page' /* 'hh' */,
      hasEdited: false,
      authForm: {},
      checkOptions: []
    };
  },
  async created() {
    store.dispatch('publicator/getBillingTypes', {
      work_site: this.field.name
    });
    await store.dispatch('publicator/checkAuth', this.field.name);

    if (
      this.platformName == 'rabotaru' &&
      this.selectedVacancy?.billing_type?.value
    ) {
      store.commit('publicator/setBillingType', {
        work_site: this.field.name,
        billingType: this.selectedVacancy.billing_type.value
      });
    }
  },
  computed: {
    auth() {
      const auth = (store.state.publicator.authForm || []).find(
        p => p.name == this.field.name
      );
      return auth ? auth.authData : {};
    },
    billingType: {
      get() {
        return this.field.activeBilling?.id || this.field.activeBilling;
      },
      set(val) {
        store.commit('publicator/setBillingType', {
          work_site: this.field.name,
          billingType: val
        });
      }
    },
    availableOptions() {
      let result = {};
      this.options.map(item => {
        result[item] = item;
      });
      return result;
    },
    workSiteOptions() {
      const obj = {
        ...this.availableOptions,
        [this.platformName]: this.platformName
      };
      const newObj = {};
      for (let key in obj) {
        newObj[key] = this.platformLabel(key);
      }

      return newObj;
    }
  },
  methods: {
    filterOptions(search_string) {
      store.dispatch('publicator/getBillingTypes', {
        work_site: this.field.name,
        search_string
      });
    },
    async checkAuthElement() {
      await store.dispatch('publicator/checkAuth', this.field.name);
    },
    async changePlatformName(value) {
      this.authForm = {};
      await store.commit('publicator/setPlatformName', {
        id: this.field.id,
        name: value,
        item: this.field
      });
      this.checkAuthElement();
      this.tabs();
      store.dispatch('publicator/getBillingTypes', {
        work_site: this.field.name
      });
      this.$emit('setFormLoading', false);
    },
    platformLabel(platformName) {
      return platformName == 'career_page'
        ? 'Карьерная страница'
        : platformName == 'hh'
        ? 'HH.ru'
        : platformName == 'avito'
        ? 'Avito'
        : platformName == 'superjob'
        ? 'SuperJob'
        : platformName == 'trudvsem'
        ? 'ТрудВсем'
        : platformName == 'rabotaru'
        ? 'Работа.Ру'
        : platformName;
    },
    handleCommand(command) {
      switch (command) {
        case 'delete':
          this.$emit('delete', { id: this.field.id, name: this.field.name });
          store.commit('publicator/setAvailableOptions', {
            name: this.field.name,
            action: 'addOpt'
          });
          this.tabs('', true);
          break;

        case 'exit':
          this.deauthenticate();
          break;

        default:
          break;
      }
    },
    setAuthValue(name, value) {
      this.authForm[name] = value;
    },
    validateForm() {
      let success = '';

      this.$nextTick(() => {
        this.$refs.form.validate(async (valid, fields) => {
          store.commit('common/setDetachedFormStatus', {
            name: this.field.name,
            valid
          });

          // detachedRules можно объединить с общими rules
          if (!valid) {
            const errorFields = Object.keys(fields);
            scrollToError(
              errorFields,
              this.isPopup ? this.$refs.form.$el : window
            );
            store.commit('common/setDetachedFormMode', false);
          }
          success = valid;
        });
      });

      return success;
    },
    async authenticate() {
      await store.dispatch('publicator/authenticate', {
        work_site: this.field.name,
        auth_form: this.authForm
      });
    },
    async deauthenticate() {
      await store.dispatch('publicator/deauthenticate', this.field.name);
    }
  },
  destroyed() {
    store.dispatch('publicator/destroyAuthInterval');
  }
};
</script>
<style lang="scss" scoped>
.authorize-form {
  .login-record {
    margin-left: 16px;
  }

  &__delete {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;

    svg {
      cursor: pointer;
    }
  }

  &__row {
    margin-bottom: 12px;
    display: flex;
    align-items: flex-end;

    .actions_menu {
      transform: translateY(-7px);
    }

    &_full {
      justify-content: space-between;
    }
  }

  &__row:last-child {
    margin-bottom: 12px;
  }

  &__input {
    &_mid {
      width: 207px;
    }

    &_sm {
      width: 143px;
    }

    &_lg {
      width: 170px;
    }
  }

  &__field {
    display: flex;
    flex-direction: column;
  }

  &__button {
    &_auth {
      width: 159px !important;
      margin-left: 16px;
      padding-left: 16px !important;
      padding-right: 16px !important;
    }

    &_log {
      margin-left: 16px;
    }
  }

  .required-star {
    display: inline;
    color: $red;
  }
}
</style>
